export const roomMixerId = {
  type: "string",
  format: "uuid"
};

export const nullableRoomMixerId = {
  ...roomMixerId,
  type: ["null", "string"]
};
